import { queryOptions } from '@tanstack/react-query'

import { SettingsService } from '@inter-ikea-kompis/core/services'
import type { IDexfSettings } from '@inter-ikea-kompis/core/types'

import { getDexfFilterSegment, KOMPIS_SERVICE_BASE_SETTINGS } from '@/integrations/kompis/constants'

export type ExtendedDexfSettings = IDexfSettings & {
  gallery: {
    'app-url': string
  }
  appsettings: {
    plannerLink: string
    showPriceDisclaimer: boolean
  }
}

export function dexfSettingsQueryOptions(locale: string) {
  return queryOptions({
    queryFn: () => getAppSettings(locale),
    queryKey: ['dexf-settings', locale],
    staleTime: Infinity,
  })
}

async function getAppSettings(locale: string) {
  const settingsService = new SettingsService({ ...KOMPIS_SERVICE_BASE_SETTINGS, locale })
  return (await settingsService.getApplicationSettings(getDexfFilterSegment())) as ExtendedDexfSettings
}
